/**
 * Descriptions written before the rich text editor existed are stored as plain
 * text; everything the editor saves is HTML (always starts with a tag).
 */
export function isRichTextHtml(value: string): boolean {
  return value.trimStart().startsWith("<");
}
